import { put, call, takeLatest } from "redux-saga/effects";
import { flashMessage } from "redux-flash";
import axios from "axios";
import { push } from "react-router-redux";
import {
  SIGNUP_REQUEST,
  SPECILITY_REQUEST,
  signupSuccess,
  signupError,
  specilitySuccess,
  specilityError,
} from "./actions";

import { saveAuthData } from "../utils/auth/authData";
import { Env } from "../../env";

function* signupRequest(action) {
  //  console.log('in signup request',action);
  var {
    email,
    password,
    firstName,
    lastName,
    multiDoctor,
    multiDoctorNames,
    specialityId,
    birthdate,
    companynumber,
    companyname,
    subdomainText,
    plan,
  } = action;
  let response;

  subdomainText = subdomainText ? subdomainText.toLowerCase() : undefined;

  try {
    let subdomain = subdomainText + ".digidocteur.com";
    response = yield call(axios.post, `${Env.BASE_API_URL}/Accounts`, {
      email,
      password,
      firstName,
      lastName,
      multiDoctor,
      multiDoctorNames,
      specialityId,
      birthdate,
      companynumber,
      companyname,
      subdomain,
      plan,
    });
  } catch (err) {
    let error;

    if (err.response && err.response.status === 401) {
      console.log("dshf", err);
      error = "Email ou mot de passe incorrect.";
    } else if (
      err.response &&
      err.response.status === 422 &&
      err.response.data &&
      err.response.data.error &&
      err.response.data.error.name === "ValidationError"
    ) {
      error = err.response.data.error.details.messages;
      error = JSON.stringify(error);
      yield put(signupError(error));
    } else {
      error = "Une erreur s'est produite, veuillez réessayer.";
      yield put(signupError(error));
    }
    return;
  }
  const authData = response.data;
  saveAuthData(authData);
  //  console.log('sdd',authData);
  yield put(signupSuccess(authData));
  // console.log('in signup request---->');
  yield put(push("/login"));
  yield put(
    flashMessage(
      "Merci ! Veuillez s'il vous plaît vérifier vos emails afin de cliquer sur le lien que nous vous avons envoyé et ainsi compléter votre inscription",
      { timeout: 10000 }
    )
  );
}
export function* watchSignupRequest() {
  yield takeLatest(SIGNUP_REQUEST, signupRequest);
}
function* specilityRequest() {
  let response1;

  try {
    response1 = yield call(axios.get, `${Env.BASE_API_URL}/Specialities`);
  } catch (err) {
    let error;

    if (
      err.response1 &&
      err.response1.status === 422 &&
      err.response1.data &&
      err.response1.data.error &&
      err.response1.data.error.name === "ValidationError"
    ) {
      error = err.response1.data.error.details.messages;
      error = JSON.stringify(error);
      yield put(specilityError(error));
    } else {
      error = "Une erreur s'est produite, veuillez réessayer.";
      yield put(specilityError(error));
    }
    return;
  }
  let authData = response1.data;
  // authData = authData.filter(x=>x.name != "Médecine générale")
  saveAuthData(authData);
  //console.log('sdd',authData);
  yield put(specilitySuccess(authData));
}
export function* watchSpecilityRequest() {
  yield takeLatest(SPECILITY_REQUEST, specilityRequest);
}

// function* logoutRequest() {
//   clearAuthData();

//   yield put(logoutSuccess());
// }

// export function* watchLogoutRequest() {
//   yield takeLatest(LOGOUT_REQUEST, logoutRequest);
// }



// WEBPACK FOOTER //
// ./src/pages/signup/saga.js